import { NgModule } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TooltipTapDirective } from './tooltip-tap.directive';

@NgModule({
  imports: [MatTooltip, TooltipTapDirective],
  exports: [MatTooltip, TooltipTapDirective],
})
export class TooltipModule {}
